@let hasAccessToThirdPartyIdentityProviderEditValue = hasAccessToThirdPartyIdentityProviderEdit();

<div class="sso-mapping-rules-banner">
  <div class="sso-mapping-rules-banner__content">
    <i class="fa-regular fa-circle-info sso-mapping-rules-banner__icon" aria-hidden="true"></i>
    <div class="sso-mapping-rules-banner__text-content">
      <span class="sso-mapping-rules-banner__text sso-mapping-rules-banner__text--bold">{{
        'sso-mapping-rules-banner.message-bold' | translate
      }}</span>
      <span class="sso-mapping-rules-banner__text">
        {{ 'sso-mapping-rules-banner.message' | translate }}
      </span>
    </div>
  </div>
  <div class="sso-mapping-rules-banner__buttons">
    <kds-small-button
      colorScheme="secondary"
      [buttonText]="'sso-mapping-rules-banner.go-to-sso' | translate"
      (buttonClick)="goToSingleSignOn()"
    />
    <span
      tooltipPosition="bottom-right"
      [kdsTooltip]="'general.missing-permission' | translate"
      [disableTooltip]="hasAccessToThirdPartyIdentityProviderEditValue"
    >
      <kds-small-button
        [buttonText]="'sso-mapping-rules-banner.acknowledge' | translate"
        [loading]="loading()"
        [disabled]="!hasAccessToThirdPartyIdentityProviderEditValue"
        (buttonClick)="acknowledgeBanner()"
      />
    </span>
  </div>
</div>
